import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit, Input, SimpleChanges, Inject, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceType } from '../../models/resource-type';
import { ItemToCategoryToComponent } from '../../models/item-to-category-to-component';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    selector: 'pdp-image-right-text-right-shop-dynamic',
    templateUrl: './image-right-text-right-shop-dynamic.component.html',
    styleUrls: ['./image-right-text-right-shop-dynamic.component.scss'],
    imports: [NgIf, SanitizeHtmlPipe],
    standalone: true
})
export class ImageRightTextRightShopDynamicComponent implements OnInit {

  private environment: any;
  public baseImageUrl: string;
  @Input()
  public resourceType: ResourceType;

  @Input()
  public items: ItemToCategoryToComponent[];
  public singleItem: ItemToCategoryToComponent;

  // set currentEnvironment in shop or offer appModule as provider.
  constructor(public router: Router, 
    @Inject('currentEnvironment') environment) {
    this.environment = environment;
  }

  ngOnInit(): void { }

  public navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['resourceType']) {
      if (this.items && this.items[0]) {
        this.singleItem = this.items[0];
      }
    }
  }
}


